import { Image, LayoutTemplate, Type, PaintBucket, Shapes } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../../ui/Tabs';
import { useUiStore, type LeftTab } from '../../../state/uiStore';
import { PhotosTab } from './PhotosTab';
import { TemplatesTab } from './TemplatesTab';
import { TextTab } from './TextTab';
import { BackgroundsTab } from './BackgroundsTab';
import { ShapesTab } from './ShapesTab';
import { t } from '../../../i18n';
import './left-panel.css';

const TABS: Array<{ key: LeftTab; icon: typeof Image; labelKey: string }> = [
  { key: 'photos', icon: Image, labelKey: 'editor.tabs.photos' },
  { key: 'templates', icon: LayoutTemplate, labelKey: 'editor.tabs.templates' },
  { key: 'text', icon: Type, labelKey: 'editor.tabs.text' },
  { key: 'backgrounds', icon: PaintBucket, labelKey: 'editor.tabs.backgrounds' },
  { key: 'shapes', icon: Shapes, labelKey: 'editor.tabs.shapes' },
];

export function LeftPanel() {
  const leftTab = useUiStore((s) => s.leftTab);
  const setLeftTab = useUiStore((s) => s.setLeftTab);

  return (
    <div className="left-panel">
      <Tabs
        value={leftTab}
        onValueChange={(v) => setLeftTab(v as LeftTab)}
        className="left-panel-tabs"
      >
        <TabsList>
          {TABS.map(({ key, icon: Icon, labelKey }) => (
            <TabsTrigger key={key} value={key} title={t(labelKey)}>
              <Icon size={15} />
            </TabsTrigger>
          ))}
        </TabsList>
        <TabsContent value="photos">
          <PhotosTab />
        </TabsContent>
        <TabsContent value="templates">
          <TemplatesTab />
        </TabsContent>
        <TabsContent value="text">
          <TextTab />
        </TabsContent>
        <TabsContent value="backgrounds">
          <BackgroundsTab />
        </TabsContent>
        <TabsContent value="shapes">
          <ShapesTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
